import gql from "graphql-tag";

export default gql`
  query GetCompanyUsers($id: ID!) {
    allUsers(filter: { company: { id: $id } }) {
      id
      email
      firstName
      lastName
      role
      phoneNumber
      jobTitle
      isATechnician
      emailVerified
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetCompanyUsers.ts